module.exports = __webpack_public_path__ + "static/img/duom03.2d45f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom03.png
// module id = 979
// module chunks = 0